import React, { useState, useRef } from 'react';
import EDIconButton from '../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDMenu from '../../../../../../BaseComponents/Menu/EDMenu';
import EDMenuItem from '../../../../../../BaseComponents/Menu/EDMenuItem';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { makeStyles } from 'tss-react/mui';
import {
  CondOperatorType,
  ExtendedOperatorType,
} from '../../../../../../Types/ClientModelTypes';
import { conditionOperators } from '../ConditionOperator/Consts/ConditionOperatorConsts';
import { NonExtendedConditionObjectType } from '../../../../../../Types/UrvalTypes';

interface IProps {
  availableConditionOperatorKeys: CondOperatorType[] | ExtendedOperatorType[];
  setConditionOperator: (
    newConditionOperator: CondOperatorType | ExtendedOperatorType
  ) => void;
  disabled?: boolean;

  conditionObject?: NonExtendedConditionObjectType;
}

const useStyles = makeStyles()(theme => ({
  symbolText: {
    marginRight: theme.spacing(1),
    width: '26px',
    backgroundColor: theme.palette.grey[200],
    padding: '2px 4px',
    textAlign: 'center',
  },
}));

const ConditionMenu: React.FC<React.PropsWithChildren<IProps>> = props => {
  const [open, setOpen] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const { classes } = useStyles();

  const availableConditionOperators = (
    props.availableConditionOperatorKeys as CondOperatorType[]
  ).map(key => ({ info: conditionOperators[key], key }));

  return (
    <>
      <EDIconButton
        tooltip="Meny"
        testId="more_vert"
        icon="more_vert"
        onClick={() => {
          setOpen(prevOpen => !prevOpen);
        }}
        color="inherit"
        padding="medium"
        iconSize="medium"
        ref={menuButtonRef}
        disabled={props.disabled}
      />
      <EDMenu
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        anchorEl={menuButtonRef.current}
        // getContentAnchorEl={null}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
      >
        <EDMenuItem header>
          <EDTypography color="primary">Byt urvalstyp</EDTypography>
        </EDMenuItem>
        {availableConditionOperators.map(availableConditionOperator => {
          return (
            <EDMenuItem
              onClick={() => {
                props.setConditionOperator(availableConditionOperator.key);
                setOpen(false);
              }}
              key={availableConditionOperator.key}
              selected={
                (props.conditionObject?.type === 'String' ||
                  props.conditionObject?.type === 'Numeric') &&
                props.conditionObject.condition[0]?.op ===
                availableConditionOperator.key
              }
            >
              <EDTypography className={classes.symbolText} bold>
                {availableConditionOperator.info.symbol}
              </EDTypography>
              <EDTypography>
                {availableConditionOperator.info.name}
              </EDTypography>
            </EDMenuItem>
          );
        })}
      </EDMenu>
    </>
  );
};

export default ConditionMenu;
